(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["why_murphy"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function () {
  const cardsContainer = document.querySelector('.cards-container');
  cardsContainer.style.scrollBehavior = 'smooth';

  // Set aspect ratio for images based on first image
  const firstImage = document.querySelector('.card-image');
  if (firstImage) {
    const img = new Image();
    img.src = firstImage.style.backgroundImage.slice(5, -2); // Extract URL from background-image
    img.onload = function() {
      const aspectRatio = img.naturalWidth / img.naturalHeight;
      document.querySelectorAll('.card-image').forEach(el => {
        el.style.aspectRatio = aspectRatio;
        el.style.height = 'auto'; // Allow height to adjust based on aspect ratio
      });
    };
  }

  // No infinite loop or auto-scroll needed since auto-rotation is disabled

  // Center the third card on desktop load
  if (window.innerWidth >= 1024) { // Assuming desktop is 1024px and above
    const cards = cardsContainer.querySelectorAll('.card-wrapper');
    if (cards.length >= 3) {
      const thirdCard = cards[2]; // Third card (0-based index)
      const containerWidth = cardsContainer.clientWidth;
      const thirdCardWidth = thirdCard.offsetWidth;
      const thirdCardOffset = thirdCard.offsetLeft;
      const centerScroll = thirdCardOffset - (containerWidth / 2) + (thirdCardWidth / 2);
      cardsContainer.scrollLeft = centerScroll;
    }
  }

  // Progress bar fill (smooth, continuous)
  function updateProgressBar(container, progressBar) {
    const maxScroll = container.scrollWidth - container.clientWidth;
    const current = container.scrollLeft;
    const percent = Math.min(current / maxScroll, 1);
    const totalLength = 286;
    const fillLength = totalLength * percent;

    const orangePath = progressBar.querySelector('path:nth-of-type(2)');
    orangePath.setAttribute('d', `M1 1H${1 + fillLength}`);
  }

  cardsContainer.addEventListener('scroll', () => {
    const progress = document.querySelector('.progress-indicator');
    if (progress) updateProgressBar(cardsContainer, progress);
  });

  // Drag Scroll (Desktop)
  let isDragging = false;
  let startX, scrollStart;

  cardsContainer.addEventListener('mousedown', (e) => {
    isDragging = true;
    startX = e.pageX;
    scrollStart = cardsContainer.scrollLeft;
  });

  cardsContainer.addEventListener('mousemove', (e) => {
    if (!isDragging) return;
    e.preventDefault();
    const walk = (e.pageX - startX) * 2;
    cardsContainer.scrollLeft = scrollStart - walk;
  });

  ['mouseup', 'mouseleave'].forEach(evt =>
    cardsContainer.addEventListener(evt, () => {
      isDragging = false;
    })
  );

  // Touch Scroll (Mobile) - Ensures swipeability
  let touchStart = 0;
  let scrollLeftTouch = 0;

  cardsContainer.addEventListener('touchstart', (e) => {
    touchStart = e.touches[0].clientX;
    scrollLeftTouch = cardsContainer.scrollLeft;
  });

  cardsContainer.addEventListener('touchmove', (e) => {
    const moveX = e.touches[0].clientX;
    const diff = (touchStart - moveX) * 2;
    cardsContainer.scrollLeft = scrollLeftTouch + diff;
  });

  cardsContainer.addEventListener('touchend', () => {
    touchStart = 0;
  });

  // Accessibility: Keyboard arrows
  cardsContainer.setAttribute('tabindex', '0');
  cardsContainer.addEventListener('keydown', (e) => {
    if (e.key === 'ArrowLeft') {
      cardsContainer.scrollLeft -= 100;
    } else if (e.key === 'ArrowRight') {
      cardsContainer.scrollLeft += 100;
    }
  });

  // Resize logic for showing progress bar
  const resizeProgress = () => {
    const indicator = document.querySelector('.progress-indicator');
    if (indicator) indicator.style.display = 'block';
  };

  resizeProgress();
  window.addEventListener('resize', resizeProgress);
});

  } catch(e) { console.error(e); }
})();
})();
